import { logger } from '../../../../utils/common/logger'
import { Store } from '../../../../utils/storage/keys'
import { IdentityPagesAPI } from './pages-api'

export class NewspapersRedirect {
    public static DOM = {
        class: {
            pageNewspapersRedirect: 'page-newspapers-redirect'
        }
    }

    constructor(public siteName: string) {}

    public async init() {
        const newspapersRedirectPage = document.querySelector(`.${NewspapersRedirect.DOM.class.pageNewspapersRedirect}`)

        if (newspapersRedirectPage) {
            try {
                const accessToken = localStorage.getItem(Store.LR_TOKEN_KEY)

                if (!accessToken) {
                    logger('info', 'User is not logged in, redirecting to non-TPA Newspapers.com page')
                    location.replace(`https://${this.siteName}.newspapers.com/`)
                    return
                }

                // get newspapers.com third-party authentication url
                const getNewspapersTpaUrlRes = await IdentityPagesAPI.getNewspapersTpaUrl(accessToken)
                const tpaUrl = getNewspapersTpaUrlRes.redirect_url
                logger('info', 'Redirecting to Newspapers.com TPA Url')
                location.replace(tpaUrl)
            } catch (error) {
                logger('error', 'API call error, Redirecting to non-TPA Newspapers.com page', error)
                // redirect to newspapers.com page without free access
                location.replace(`https://${this.siteName}.newspapers.com/`)
            }
        }
    }
}
